import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  opportunities: [],
  error: false,
  loading: false,
  lastSync: false,
};

const initialState = defineState(defaultState)('opportunities');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.opportunities.length > 0 ? action.opportunities : [];  
  return updateObject(state, {
    opportunities: result,
    error: false,
    loading: false,
    lastSync: new Date(),
  })
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, opportunities: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_OPPORTUNITIES_START:
      return fetchStart(state);
    case actionTypes.FETCH_OPPORTUNITIES_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_OPPORTUNITIES_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false,
      };
  }
};

export default reducer;
